import React from "react";
import { Popular } from "pages";

const PopularRoute = () => {
  return (
    <>
      <Popular />
    </>
  );
};

export default PopularRoute;
